import { writable } from 'svelte/store';
export function debounce(func, wait) {
    let timeout = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (...args) {
        const later = () => {
            timeout = null;
            try {
                func(...args);
            }
            catch (e) {
                console.log(`Exception: ${func.name}`, e, args);
            }
        };
        // this will wait for wait number if milliseconds w/o any call to the debounced function in order to execute the
        // debounced function, guaranteeing only that it doesn't run more than once per wait period
        // it runs on the last call not the first call, which can cause delay
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = window.setTimeout(later, wait);
    };
}
export function debounceAsync(func, wait) {
    let timeout = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (...args) {
        const later = async () => {
            timeout = null;
            try {
                await func(...args);
            }
            catch (e) {
                console.log(`Exception: ${func.name}`, e, args);
            }
        };
        // this will wait for wait number if milliseconds w/o any call to the debounced function in order to execute the
        // debounced function, guaranteeing only that it doesn't run more than once per wait period
        // it runs on the last call not the first call, which can cause delay
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = window.setTimeout(later, wait);
    };
}
export function once(func) {
    let called = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (...args) {
        if (called) {
            // console.log(`not calling Once ${func.name} because it was already called`);
            return;
        }
        called = true;
        try {
            //console.log(`calling Once ${func.name}`, args);
            func(...args);
        }
        catch (e) {
            called = false;
            throw e;
        }
    };
}
export function onceAsync(func) {
    let called = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async function (...args) {
        if (called) {
            //console.log(`not calling asyncOnce ${func.name} because it was already called`);
            return;
        }
        called = true;
        try {
            // console.log(`calling asyncOnce ${func.name}`, args);
            await func(...args);
        }
        catch (e) {
            called = false;
            throw e;
        }
    };
}
export function onceInTime(func, timeout) {
    let called = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (...args) {
        if (called && Date.now() - called < timeout) {
            // console.log(
            // 	`not calling onceInTime ${func.name} because it was called ${Date.now() - called}ms ago and should not be called more than once every ${timeout}ms`
            // );
            return;
        }
        called = Date.now();
        try {
            // console.log(`calling onceInTime ${func.name}`, args);
            func(...args);
        }
        catch (e) {
            called = 0;
            throw e;
        }
    };
}
export function onceInTimeAsync(func, timeout) {
    let called = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async function (...args) {
        if (called && Date.now() - called < timeout) {
            // console.log(
            // 	`not calling asyncOnceInTime ${func.name} because it was called ${Date.now() - called}ms ago and should not be called more than once every ${timeout}ms`
            // );
            return;
        }
        called = Date.now();
        try {
            // console.log(`calling asyncOnceInTime ${func.name}`, args);
            await func(...args);
        }
        catch (e) {
            called = 0;
            throw e;
        }
    };
}
export function onceInTimeAsyncWithCatch(func, timeout) {
    let called = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async function (...args) {
        if (called && Date.now() - called < timeout) {
            // console.log(
            // 	`not calling asyncOnceInTimeWithCatch ${func.name} because it was called ${Date.now() - called}ms ago and should not be called more than once every ${timeout}ms`
            // );
            return;
        }
        called = Date.now();
        try {
            // console.log(`calling asyncOnceInTimeWithCatch ${func.name}`, args);
            await func(...args);
        }
        catch (e) {
            called = 0;
            console.log(`Exception: ${func.name}`, e, args);
        }
    };
}
